import { Button, Input, Row } from "antd";
import axios from 'axios';
import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { Alert } from "rsuite";
import logo from "../../assets/images/satisfi_black.svg";
import constants from "../../constants";
import services from "../../services";

const api = services.api;
const hostname = window.location.hostname;
const recaptchaRef = React.createRef();

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      validEmail: false,
      isEmailSent: false,
      errorMessage:"",
      disabledButton : false,
			recaptchaValidation: null,
			reCaptchaValue: null,
    };
  }

  onChangeRecaptcha = (value) => {
		this.setState({
			recaptchaValidation: true,
			reCaptchaValue: value,
		});
	};

	onExpiredRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

	onErrorRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

  onSubmit = () => {
    this.setState({
      disabledButton : true
    });
    if (this.state.validEmail) {
      let reqObj = {
        email: this.state.email,
        url: constants.forgot_password_payload_url,
        recaptchaValue: this.state.reCaptchaValue
      };
      axios.post(constants.forgotPassword, reqObj).then((response) => {
        Alert.success(`Reset password link sent to email id ${this.state.email}.`);
      }).catch((error) => {
        console.log(error.response);
        if (error.response && error.response.status === 429) {
          Alert.error("Too many attempts, please try after a minute");
        }
      }).finally(() => {
        this.setState({
          disabledButton : false,
          reCaptchaValue: null,
          recaptchaValidation: null
        });
        if (constants.captcha_whitelist.includes(hostname)) {
          recaptchaRef.current.reset();
        }
      });
    } else {
      Alert.error("Invalid email");
      this.setState({
        disabledButton : false
      });
    }

  };

  inputEntered = (e) => {
    if (constants.EMAIL_VALIDATION_REGEX.test(e.target.value)) {
      this.setState({ validEmail: true, errorMessage: "", disabledButton: false });
    } else {
      this.setState({ validEmail: false, errorMessage: "This is not valid email address", disabledButton: true });
    }
    this.setState({ email: e.target.value });
  };

  render() {
    return (  
      <section className="login" style={{justifyContent: "center"}}>
        {/* <div className="col-md-6 col-sm-6 col-xs-12 login-left-container">
          <Login image={login1} loginType="forgotpassword" imgStyle={{ width: "400px" }} />
        </div> */}
        <Row justify={"center"} align={"middle"}>
        <div className=" emailstyle forgot-reset-container" style={{maxWidth: "548px"}}>
          <div className="login-inner-container">
            <img src={logo} height={"40px"} className="mb-4"/>
            <div style={{fontSize: "32px", fontWeight: "500"}}>Forgot your password? Let’s get you a new one.</div>
            <p className="account">
                Remembered Password?<Link to="/signin"><span>Log In</span></Link>
            </p>
            <p className="forget">Don’t worry. Resetting your password is easy, just tell us your email address you registered with Marketing Engine.</p>
            <Input 
              containerClass="col-md-12 col-sm-12 col-xs-12 pl-0"
              type="email"
              name="email"  
              maxLength={320}
              placeholder="Email Address"
              value={this.state.email}  
              onChange={this.inputEntered}
              className="forgotInput"
            />
            <div className="error-msg">{this.state.errorMessage || this.state.errorMessage!== "" ? this.state.errorMessage: null}</div>
            <div style={{"marginTop": "20px"}}>
							{constants.captcha_whitelist.includes(hostname) && (
								<ReCAPTCHA
									sitekey={constants.recaptchaSitekey}
									onChange={this.onChangeRecaptcha}
									onExpired={this.onExpiredRecaptcha}
									onErrored={this.onErrorRecaptcha}
									size='normal'
									ref={recaptchaRef}
								/>
							)}
						</div>
            <Button onClick={this.onSubmit} disabled={this.state.disabledButton || (constants.captcha_whitelist.includes(hostname) && !this.state.recaptchaValidation)} className="forgotButton">
              Submit
            </Button>
          </div>
        </div>
        </Row>
    
      </section>
    );
  }
}
